export const IMG_URL = "https://server.yuksalishsocks.uz";
